import { action, observable, computed, toJS } from "mobx";
import { formatDate, formatDateOnly } from "utility.js";

const STORE_WORKSHIFT = "workshift";

class WorkshiftStore {
  configStore;

  constructor(rawState = {}, configStore) {
    this.configStore = configStore;

    if (rawState.items) {
      this.setItems(rawState.items);
    }
    if (rawState.search) {
      this.setSearch(rawState.search);
    }
  }
  toJS() {
    return {
      items: toJS(this.items),
      search: toJS(this.search),
    };
  }

  @observable items = [];
  @action setItems(value) {
    value = value.filter((item) => {
      const details = JSON.parse(item.Details).Details;
      if (details.Response && details.Response.Error) return false;

      switch (item.Operation) {
        case "CreatePallet":
        case "ModifyPallet":
        case "DeletePallet":
        case "ProcessPallet":
        case "ReprocessPallet":
        case "MixturePallet":
        case "SellPallet":
          return true;
        case "SetPalletProperty":
          if (details.Request.DataType === "BinId") return false;
          return true;
        default:
          return false;
      }
    });

    value.sort((a, b) => {
      return a.Timestamp < b.Timestamp ? -1 : 1;
    });

    const bins = {};
    this.configStore.bins.forEach((bin) => {
      bins[bin.id] = bin;
    });

    this.items = value.map((event) => {
      event.UserName = this.configStore.users[event.UserId]
        ? this.configStore.users[event.UserId].Name
        : "";
      event.Timestamp = formatDate(event.Timestamp);

      const details = JSON.parse(event.Details).Details;
      delete event.Details;
      event.Details = {};
      event.FilterField = event.UserName + " ";

      const requestdata = details.Request.Data;

      event.BagCount = requestdata.BagCount;
      event.Quantity = requestdata.Quantity;

      switch (event.Operation) {
        case "CreatePallet":
          event.Details.Operation = "Létrehozás";
          event.Details.Item = this.configStore.items[requestdata.ItemId];
          if (requestdata.CustomItem)
            event.Details.CustomItem = requestdata.CustomItem;
          event.Details.LotNo = requestdata.LotNo;
          if (requestdata.SealNum) event.Details.SealNum = requestdata.SealNum;
          event.Details.CleaningRate =
            this.configStore.cleaningRates[requestdata.CleaningRate];
          event.Details.Machine =
            this.configStore.machines[requestdata.MachineId].Name;
          event.Details.CleaningCount = requestdata.CleaningCount;
          event.Details.Quantity =
            (requestdata.BagType === "BigBag"
              ? requestdata.Quantity
              : requestdata.BagCount + " x " + requestdata.Quantity) + " kg";
          if (requestdata.Dressing)
            event.Details.Dressing = requestdata.Dressing;
          event.Details.Supplier =
            this.configStore.suppliers[parseInt(requestdata.SupplierId)];
          if (requestdata.CustomSupplier)
            event.Details.CustomSupplier = requestdata.CustomSupplier;
          break;

        case "ModifyPallet":
          event.Details.Operation = "Módosítás";
          event.Details.Item = this.configStore.items[requestdata.ItemId];
          if (requestdata.CustomItem)
            event.Details.CustomItem = requestdata.CustomItem;
          event.Details.LotNo = requestdata.LotNo;
          if (requestdata.SealNum) event.Details.SealNum = requestdata.SealNum;
          event.Details.CleaningRate =
            this.configStore.cleaningRates[requestdata.CleaningRate];
          event.Details.Machine =
            this.configStore.machines[requestdata.MachineId].Name;
          event.Details.CleaningCount = requestdata.CleaningCount;
          event.Details.Quantity =
            (requestdata.BagType === "BigBag"
              ? requestdata.Quantity
              : requestdata.BagCount + " x " + requestdata.Quantity) + " kg";
          if (requestdata.Dressing)
            event.Details.Dressing = requestdata.Dressing;
          event.Details.Supplier =
            this.configStore.suppliers[parseInt(requestdata.SupplierId)];
          if (requestdata.CustomSupplier)
            event.Details.CustomSupplier = requestdata.CustomSupplier;
          break;

        case "SetPalletProperty":
          event.Details.Operation = "Webes módosítás";
          event.Details.Item = this.configStore.items[event.Pallet.ItemId];
          if (event.Pallet.CustomItem)
            event.Details.CustomItem = event.Pallet.CustomItem;
          event.Details.LotNo = event.Pallet.LotNo;
          if (event.Pallet.SealNum)
            event.Details.SealNum = event.Pallet.SealNum;
          switch (details.Request.DataType) {
            case "Quantity":
              event.Details.Quantity =
                (requestdata.BagType === 1
                  ? requestdata.Quantity
                  : requestdata.BagCount + " x " + requestdata.Quantity) +
                " kg";
              break;

            case "Machine":
              event.Details.Machine =
                this.configStore.machines[requestdata.MachineId].Name +
                " x " +
                requestdata.CleaningCount;
              break;

            case "CleaningRate":
              event.Details.CleaningRate =
                this.configStore.cleaningRates[requestdata.CleaningRate];
              break;

            case "BinId":
              event.Details.Bin = this.configStore.bins[requestdata.BinId].Name;
              break;
          }
          break;

        case "DeletePallet":
          event.Details.Operation = "Törlés";
          event.Details.Item = this.configStore.items[event.Pallet.ItemId];
          if (event.Pallet.CustomItem)
            event.Details.CustomItem = event.Pallet.CustomItem;
          event.Details.LotNo = event.Pallet.LotNo;
          if (event.Pallet.SealNum)
            event.Details.SealNum = event.Pallet.SealNum;
          event.Details.CleaningRate =
            this.configStore.cleaningRates[event.Pallet.CleaningRate];
          break;

        case "ProcessPallet":
          event.Details.Operation = "Feldolgozás";
          event.Details.Item = this.configStore.items[event.Pallet.ItemId];
          if (event.Pallet.CustomItem)
            event.Details.CustomItem = event.Pallet.CustomItem;
          event.Details.LotNo = event.Pallet.LotNo;
          if (event.Pallet.SealNum)
            event.Details.SealNum = event.Pallet.SealNum;
          event.Details.CleaningRate =
            this.configStore.cleaningRates[event.Pallet.CleaningRate];
          break;

        case "ReprocessPallet":
          event.Details.Operation = "Újradolgozás";
          event.Details.Item = this.configStore.items[event.Pallet.ItemId];
          if (event.Pallet.CustomItem)
            event.Details.CustomItem = event.Pallet.CustomItem;
          event.Details.LotNo = event.Pallet.LotNo;
          if (event.Pallet.SealNum)
            event.Details.SealNum = event.Pallet.SealNum;
          event.Details.CleaningRate =
            this.configStore.cleaningRates[event.Pallet.CleaningRate];
          break;

        case "MixturePallet":
          event.Details.Operation = "Keverékhez felhasználás";
          event.Details.Item = this.configStore.items[event.Pallet.ItemId];
          if (event.Pallet.CustomItem)
            event.Details.CustomItem = event.Pallet.CustomItem;
          event.Details.LotNo = event.Pallet.LotNo;
          if (event.Pallet.SealNum)
            event.Details.SealNum = event.Pallet.SealNum;
          event.Details.CleaningRate =
            this.configStore.cleaningRates[event.Pallet.CleaningRate];
          event.Details.Quantity =
            (requestdata.BagType === "BigBag"
              ? requestdata.Quantity
              : requestdata.BagCount + " x " + requestdata.Quantity) + " kg";
          break;

        case "SellPallet":
          event.Details.Operation = "Értékesítés";
          event.Details.Item = this.configStore.items[event.Pallet.ItemId];
          if (event.Pallet.CustomItem)
            event.Details.CustomItem = event.Pallet.CustomItem;
          event.Details.LotNo = event.Pallet.LotNo;
          if (event.Pallet.SealNum)
            event.Details.SealNum = event.Pallet.SealNum;
          event.Details.Quantity =
            (event.Pallet.BagType === "BigBag"
              ? requestdata.Amount
              : requestdata.Amount + " x " + event.Pallet.Quantity) + " kg";
          event.Details.CleaningRate =
            this.configStore.cleaningRates[event.Pallet.CleaningRate];
          if (event.Pallet.MachineId)
            event.Details.Machine =
              this.configStore.machines[event.Pallet.MachineId].Name;
          if (event.Pallet.SupplierId)
            event.Details.Supplier =
              this.configStore.suppliers[parseInt(event.Pallet.SupplierId)];
          if (event.Pallet.CustomItem)
            event.Details.CustomSupplier = event.Pallet.CustomItem;
          break;
      }

      Object.values(event.Details).forEach((detail) => {
        event.FilterField +=
          event.Timestamp +
          " " +
          event.UserName.toLowerCase() +
          " " +
          (detail ? detail.toString().toLowerCase() : "") +
          " ";
      });

      return event;
    });
  }

  @computed get filteredItems() {
    if (!this.search) {
      return this.items;
    }
    return observable(
      this.items.filter((item) => {
        const searches = this.search.split(" ");
        for (let i = 0; i < searches.length; i++) {
          const s = searches[i].toLowerCase();
          //console.log(s, item.FilterField)
          if (item.FilterField.indexOf(s) === -1) {
            return false;
          }
        }
        return true;

        for (let fieldValue of Object.values(item)) {
          if (("" + fieldValue).indexOf(this.search) > -1) {
            return true;
          }
        }
        return false;
      }),
    );
  }

  @computed get shownItems() {
    return this.filteredItems;
    return this.filteredItems.slice(0, this.logCount);
  }

  @observable date;
  @action setDate(value) {
    this.date = value;
  }
  @computed get toFormatted() {
    return formatDateOnly(this.to);
  }

  @observable workshift;
  @action setWorkshift(value) {
    this.workshift = value;
  }

  @observable search = "";
  @action setSearch(value) {
    this.search = value;
  }
}

export { WorkshiftStore, STORE_WORKSHIFT };
